import React, { useState, useEffect } from "react";
import { Panel, PanelBody } from "./../../components/panel/panel.jsx";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import CreatableSelect from "react-select/creatable";
import NavigationButton from "../../components/constantComponent/button/NavigationButton";
import {
  ApiKey,
  ApiUrl,
  TransactionType,
  PanelType,
  LanguageKey,
  DEFAULT_PAGE_SIZE,
} from "../../util/Constant";
import { stringIsNullOrEmpty, createFormBody } from "../../util/Util";
import { useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiEngine from "../../util/ApiEngine";
import { AsyncPaginate } from "react-select-async-paginate";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import PinInput from 'react-pin-input';
import { Modal, ModalHeader, ModalBody } from "reactstrap";

/// <summary>
/// Author : -
/// </summary>
const Adjustment = (props) => {
  const { t } = useTranslation(LanguageKey._PRIMARY);
  let _history = useHistory();
  const _location = useLocation();
  const _dispatch = useDispatch();
  const {
    register,
    unregister,
    handleSubmit,
    errors,
    setValue,
    trigger,
    control,
  } = useForm();
  const [memberOption, setMemberOption] = useState([]);
  const [memberId, setMemberId] = useState("");
  const [fullScreen, setFullScreen] = useState(false);
  const [remarkOption, setRemarkOption] = useState([]);
  const [selectedMember, setSelectedMember] = useState();

  const [showPinEntry, setShowPinEntry] = useState(false);

  const [enteredAdjustmentData, setEnteredAdjustmentData] = useState({});
  const [enteredAdjustmentE, setEnteredAdjustmentE] = useState({});
  const [textLimit]=useState(2);
  const [tooltipText]=useState(`Input at least ${textLimit} characters to search`)
  const [displayToolTip, setDisplayToolTip] = useState(false);
  const [rolloverOption, setRolloverOption] = useState("");
  const [rolloverMultiplier, setRolloverMultiplier] = useState("");
  const [rolloverFixed, setRolloverFixed] = useState("");
  const [finalRolloverAmount, setFinalRolloverAmount] = useState("");
  const [amount, setAmount] = useState("");

  const handleInputChange = (selectedOption) => {
      if(textLimit>0){
  setDisplayToolTip(selectedOption.length > 0 && selectedOption.length < textLimit);
      }
  };
  const [key, setKey] = useState(0);


  /// <summary>
  /// Author : -
  /// Editted : -
  /// </summary>
  useEffect(() => {
    register({ name: "memberId" }, { required: "PLEASE_SELECT_MEMBER" });

    /// For The Size Difference of Modal And Page
    if (props.id) {
      setFullScreen(true);
    }

    init();
    initFormField();
  }, []);

  useEffect(() => {
    if(stringIsNullOrEmpty(rolloverOption)) {
      setFinalRolloverAmount("");
      return;
    }

    if (selectedMember != null && rolloverOption === "multi" && rolloverMultiplier !== "") {
      setFinalRolloverAmount(selectedMember.rollOverBalance + (amount * rolloverMultiplier));
      return;
    }

    if (selectedMember != null && rolloverOption === "fixed" && !stringIsNullOrEmpty(rolloverFixed)) {
      setFinalRolloverAmount(selectedMember.rollOverBalance + parseFloat(rolloverFixed));
      return;
    }

    setFinalRolloverAmount("");

  }, [amount, rolloverMultiplier, rolloverFixed]);

  /// <summary>
  /// Author : -
  /// Editted : - (Added Fetch to get IP Address)
  /// </summary>
  async function init() {
    try {
      _dispatch(setBusy());
      let responseJson = await ApiEngine.get(ApiUrl._API_GET_USER_REMARK);
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        const remarkList = [];
        responseJson[ApiKey._API_DATA_KEY].forEach(function (remark) {
          remarkList.push({
            label: remark.description,
            value: remark.description,
          });
        });

        setRemarkOption(remarkList);
      } else {
        throw t(responseJson[ApiKey._API_MESSAGE_KEY]);
      }
    } catch (error) {
      _dispatch(showMessage(false, error));
    } finally {
      _dispatch(setIdle());
    }
  }

  /// <summary>
  /// Author : -
  /// </summary>
  const initFormField = () => {
    if (stringIsNullOrEmpty(props.id)) {
      setMemberId("");
      setValue("memberId", "");
      getMemberList("", null, { page: 1 });
      setSelectedMember(null);
    } else {
      setMemberId(props.id);
      setValue("memberId", props.id);
    }
    setValue("amount","");
    setValue("rolloverMultiplier","");
    setValue("rolloverFixed","");
    setValue("remark", "");
  };

  /// <summary>
  /// Author : -
  /// Editted : -
  /// </summary>
  const submitForm = async (data, e) => {
    let params = {
      //transactionTypeId: TransactionType._ADJUSTMENT,
      memberId: memberId,
      amount: data.amount,
      panel: PanelType._BACKOFFICE,
      remark: data.remark,
      rolloverType:JSON.stringify({
        option:rolloverOption?(rolloverOption === 'multi'?1:2):0,
        value:rolloverOption?(rolloverOption === 'multi'?rolloverMultiplier:rolloverFixed):"0"
      })
    };

    if (!stringIsNullOrEmpty(rolloverOption) && !stringIsNullOrEmpty(finalRolloverAmount)) {
      params.rolloverBalance = finalRolloverAmount;
    }

    let formBody = createFormBody(params);

    let responseJson = await ApiEngine.post(
      ApiUrl._API_CREATE_TRANSACTION_ADJUSTMENT,
      formBody
    );

    _dispatch(
      showMessage(
        responseJson[ApiKey._API_SUCCESS_KEY],
        t(responseJson[ApiKey._API_MESSAGE_KEY])
      )
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      e.target.reset();
      initFormField();
      setFinalRolloverAmount("");
      setRolloverOption("");
      setRolloverMultiplier("");
      setRolloverFixed("");

      if (props.onComplete != null) {
        props.onComplete();
      }
    }

    setShowPinEntry(false);
    setKey((prev) => prev + 1);
  };

  /// <summary>
  /// Author : Wong
  /// </summary>
  async function getMemberList(search, loadOptions, { page }) {
    let formattedData=[];
		
		if(search.length>=textLimit){
    var responseJson = await ApiEngine.get(
      `${ApiUrl._API_GET_USER_MEMBER_LIST}?start=${
        (page - 1) * DEFAULT_PAGE_SIZE
      }&count=${DEFAULT_PAGE_SIZE}&keyword=${search}`
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY]["data"];
      formattedData = data.map((m) => {
        return { label: m.username, value: m.id, balance: m.primaryCredit, rollOverBalance: m.rollOverBalance };
      });
    }
   }
   
   return {
    options: formattedData,
    hasMore: formattedData.length == DEFAULT_PAGE_SIZE,
    additional: {
      page: page + 1,
    },
  };
  }

  async function onPinSubmit(data, e) {
    // verify pin
    let params = { transactionPinNumber: data };
    let formBody = createFormBody(params);
    let responseJson = await ApiEngine.post(ApiUrl._API_VERIFY_USER_TRANSACTION_PIN_NUMBER, formBody);

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      submitForm(enteredAdjustmentData, enteredAdjustmentE);
    }
    else {
      _dispatch(showMessage(false, t("INCORRECT") + " " + t("PIN_NUMBER")));
      setShowPinEntry(false);
    }
  }

  async function checkPinValue(data, e) {
    // check if pin has 4 digits (valid pin)
    // if true then submit pin
    if (data.length == 4) {
      onPinSubmit(data);
    }

  }

  async function onSubmit(data, e) {
    setEnteredAdjustmentData(data);
    setEnteredAdjustmentE(e);

    setShowPinEntry(true);
    }
  
  const handleFocus = (e) => {
    e.target.select();
  };

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    const char = String.fromCharCode(charCode);

    // Allow numbers (0-9), one decimal point, and a minus sign only at the start
    if (!/[0-9]/.test(char) && char !== '.' && char !== '-') {
      e.preventDefault();
    }

    // only one decimal point
    if (char === '.' && e.target.value.includes('.')) {
      e.preventDefault(); // prevent more than one decimal
    }
  };

  return (
    <div>
      <h1 className="page-header">
        <div className="page-title">
          <NavigationButton history={_history} />
          {t("ADJUSTMENT")}
        </div>
        <div className="page-actions">
          {props.id && (
            <button
              style={{ float: "right" }}
              className="btn btn-inverse"
              onClick={() => {
                props.toggleModal(false);
              }}
            >
              <i className="fa fa-times"></i>
            </button>
          )}
        </div>
      </h1>

      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelBody>
              <form onSubmit={handleSubmit(submitForm)}>
                <div className="row">
                  <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                        <b>{t("USERNAME")}</b>
                      </label>
                      <div className="col-md-7">
                      <OverlayTrigger
                       placement="top"
                       overlay={<Tooltip>{tooltipText}</Tooltip>}
                       show={displayToolTip}
                      >
                          <div className="async-paginate">  
                          {
                        <AsyncPaginate
                          name="memberId"
                          placeholder={
                            selectedMember ? selectedMember.label : ""
                          }
                          key={key }
                          isDisabled={!stringIsNullOrEmpty(props.id)}
                          debounceTimeout={250}
                          loadOptions={getMemberList}
                          additional={{
                            page: 1,
                          }}
                          value={selectedMember}
                          onChange={(e) => {
                            setValue("memberId", e.value);
                            setMemberId(e.value);
                            setSelectedMember(e);
                            trigger("memberId");
                          }}
                          onInputChange={handleInputChange}
                        />
                      }
                      </div>
                      </OverlayTrigger> 
                        {errors.memberId && (
                          <div className="invalid-feedback">
                            {t(errors.memberId.message)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                        <b>
                          {t("AMOUNT")}
                          <label style={{ color: "blue", paddingLeft: "5px" }}>
                            {selectedMember && `(${selectedMember.balance})`}
                          </label>
                        </b>
                      </label>
                      <div className="col-md-7">
                      <input
                          type="text"
                          className="form-control"
                          defaultValue={amount}
                          name="amount"
                          placeholder={t("PLEASE_ENTER_AMOUNT")}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setValue("amount", newValue);
                            setAmount(newValue);
                          }}
                          ref={register({
                            validate: (value) => {

                              if(selectedMember && (value === null || value.toString().trim() === '')){
                                return "PLEASE_ENTER_AMOUNT";
                              }
                              
                              if(selectedMember){
                              const parsed = value.toString().trim() === '' ? NaN : Number(value);
                              if (!Number.isFinite(parsed)) {
                                return "VALID_NUMBER";
                              }                  
                        
                              const leadingZeroPattern = /^-?0\d+/;
                              if (leadingZeroPattern.test(value)) {
                                return "PLEASE_DO_NOT_ENTER_LEADING_ZEROS";
                              }
                        
                              const decimalPattern = /^-?\d+(\.\d{0,3})?$/;
                              if (!decimalPattern.test(value)) {
                                return "DECIMAL_CONDITION";
                              }
                        
                              const minValue=selectedMember?selectedMember.balance*-1:0;
                              if (parsed < minValue) {
                                return "PLEASE_ENTER_VALUE_NOT_LESS_THAN";
                              }
                            } 
                        
                              return true;
                            },
                          })}
                        />
                        {/* <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          placeholder={t("PLEASE_ENTER_AMOUNT")}
                          name="amount"
                          ref={register({
                            required: "PLEASE_ENTER_AMOUNT",
                            //validate: (value) =>
                            //  parseFloat(value) != 0 ||
                            //  "PLEASE_DO_NOT_ENTER_ZERO",
                            min: {
                              value: selectedMember
                                ? selectedMember.balance * -1
                                : 0,
                              message: "PLEASE_ENTER_VALUE_NOT_LESS_THAN",
                            },
                          })}
                          onChange={(e) => {
                            setAmount(e.target.value);
                          }}
                        /> */}
                        {errors.amount && (
                          <div className="invalid-feedback">
                            {t(errors.amount.message, {
                              value: selectedMember
                                ? selectedMember.balance * -1
                                : 0,
                                num:3
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                        <b>{t("ROLLOVER_TYPE")}
                          <label style={{ color: "blue", paddingLeft: "5px" }}>
                            {selectedMember && `(${selectedMember.rollOverBalance})`}
                          </label><br />
                          <small>*{t("OPTIONAL")}</small>
                        </b>
                      </label>
                      <div className="col-md-7 align-content-center">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="radio">
                              <Controller
                                name="rolloverType"
                                control={control}
                                defaultValue="multi"
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="radio"
                                      id="rolloverTypeMulti"
                                      value="multi"
                                      onChange={(e) => {
                                        setValue('rolloverType', e.target.value);
                                        setRolloverOption(e.target.value);
                                      }}
                                      checked={rolloverOption === 'multi'}
                                    />
                                    <label htmlFor="rolloverTypeMulti">{t("MULTIPLIER")}</label>
                                  </>
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="radio">
                              <Controller
                                name="rolloverType"
                                control={control}
                                defaultValue="fixed"
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="radio"
                                      id="rolloverFixed"
                                      value="fixed"
                                      onChange={(e) => {
                                        setValue('rolloverType', e.target.value);
                                        setRolloverOption(e.target.value);
                                      }}
                                      checked={rolloverOption === 'fixed'}
                                    />
                                    <label htmlFor="rolloverFixed">{t("FIXED_AMOUNT")}</label>
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {rolloverOption === 'multi' && <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                      </label>
                      <div className="col-md-7">
                        <div className="row">
                          <div className="col-md-4">
                            <small>{t("ROLLOVER_MULTIPLIER")} (x):</small>
                            <input
                          type="text"
                          className="form-control"
                          defaultValue={rolloverMultiplier}
                          name="rolloverMultiplier"
                          placeholder={""}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setValue("rolloverMultiplier", newValue);
                            setRolloverMultiplier(newValue);
                          }}
                          ref={register({
                            validate: (value) => {

                              if (value.toString().trim() === '') return true;

                              const parsed = value.toString().trim() === '' ? NaN : Number(value);
                              if (!Number.isFinite(parsed)) {
                                return "VALID_NUMBER";
                              }                  
                        
                              const leadingZeroPattern = /^-?0\d+/;
                              if (leadingZeroPattern.test(value)) {
                                return "PLEASE_DO_NOT_ENTER_LEADING_ZEROS";
                              }
                        
                              const decimalPattern = /^-?\d+(\.\d{0,2})?$/;
                              if (!decimalPattern.test(value)) {
                                return "DECIMAL_CONDITION";
                              }
                        
                              if (parseFloat(finalRolloverAmount) < 0) {
                                return "ROLLOVER_BALANCE_NOT_LESS_THAN_0";
                              }
                        
                              return true;
                            },
                          })}
                        />
                            {/* <input
                              type="number"
                              step="0.01"
                              className="form-control"
                              // defaultValue={rolloverMultiplier}
                              defaultValue={rolloverMultiplier}
                              name="rolloverMultiplier"
                              onFocus={handleFocus}
                              onKeyPress={handleKeyPress}
                              onChange={(e) => {
                                const newValue = e.target.value
                                if (/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                  setValue('rolloverMultiplier', newValue);
                                  setRolloverMultiplier(newValue);
                                }

                                if (newValue === "") {
                                  setValue('rolloverMultiplier', "");
                                  setRolloverMultiplier("");
                                }
                              }}
                              ref={register({
                                validate: (value) =>
                                  parseFloat(finalRolloverAmount) >= 0 ||
                                  "ROLLOVER_BALANCE_NOT_LESS_THAN_0",
                              })}
                            /> */}
                            {errors.rolloverMultiplier && (
                              <div className="invalid-feedback">
                                {t(errors.rolloverMultiplier.message,{num:2})}
                              </div>
                            )}
                          </div>
                          {/*<div className="col-md-4">*/}
                          {/*  <small>{t("FINAL_ROLLOVER_AMOUNT")}:</small>*/}
                          {/*  <input*/}
                          {/*    disabled*/}
                          {/*    type="text"*/}
                          {/*    ref={register()}*/}
                          {/*    className="form-control"*/}
                          {/*    defaultValue={rolloverMultiplier}*/}
                          {/*    name="finalRolloverAmount"*/}
                          {/*    value={finalRolloverAmount}*/}
                          {/*    ref={register({*/}
                          {/*      validate: (value) =>*/}
                          {/*        parseFloat(finalRolloverAmount) >= 0 ||*/}
                          {/*        "ROLLOVER_BALANCE_NOT_LESS_THAN_0",*/}
                          {/*    })}*/}
                          {/*  />*/}
                          {/*</div>*/}
                        </div>
                        </div>
                    </div>
                  </div>}

                  {rolloverOption === 'fixed' && <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                      </label>
                      <div className="col-md-7">
                        <div className="row">
                          <div className="col-md-4">
                            <small>{t("ROLLOVER_FIXED_AMOUNT")} ($):</small>
                            <input
                          type="text"
                          className="form-control"
                          defaultValue={rolloverFixed}
                          name="rolloverFixed"
                          placeholder={""}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setValue("rolloverFixed", newValue);
                            setRolloverFixed(newValue);
                          }}
                          ref={register({
                            validate: (value) => {

                              if (value.toString().trim() === '') return true;

                              const parsed = value.toString().trim() === '' ? NaN : Number(value);
                              if (!Number.isFinite(parsed)) {
                                return "VALID_NUMBER";
                              }                  
                        
                              const leadingZeroPattern = /^-?0\d+/;
                              if (leadingZeroPattern.test(value)) {
                                return "PLEASE_DO_NOT_ENTER_LEADING_ZEROS";
                              }
                        
                              const decimalPattern = /^-?\d+(\.\d{0,3})?$/;
                              if (!decimalPattern.test(value)) {
                                return "DECIMAL_CONDITION";
                              }
                        
                              if (parseFloat(finalRolloverAmount) < 0) {
                                return "ROLLOVER_BALANCE_NOT_LESS_THAN_0";
                              }
                        
                              return true;
                            },
                          })}
                        />
                            {/* <input
                              type="text"
                              className="form-control"
                              // defaultValue={rolloverFixed}
                              defaultValue={rolloverFixed}
                              name="rolloverFixed"
                              onFocus={handleFocus}
                              onKeyPress={handleKeyPress}
                              onChange={(e) => {
                                const newValue = e.target.value;
                               if (/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                  setValue('rolloverFixed', newValue);
                                  setRolloverFixed(newValue);
                                }
                              }}
                              ref={register({
                                validate: (value) =>
                                  parseFloat(finalRolloverAmount) >= 0 ||
                                  "ROLLOVER_BALANCE_NOT_LESS_THAN_0",
                              })}
                            /> */}
                            {errors.rolloverFixed && (
                              <div className="invalid-feedback">
                                {t(errors.rolloverFixed.message,{num:3})}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                  <div className={fullScreen ? "col-lg-12" : "col-lg-8"}>
                    <div className="form-group row m-b-15">
                      <label className="col-md-4 col-form-label">
                        <b>{t("REMARK")}</b>
                      </label>
                      <div className="col-md-7">
                        <Controller
                          name="remark"
                          control={control}
                          render={({ value, onChange }) => {
                            return (
                              <CreatableSelect
                                options={remarkOption}
                                placeholder={
                                  remarkOption.filter(
                                    (option) => option.value == value
                                  )[0] !== undefined
                                    ? remarkOption.filter(
                                        (option) => option.value == value
                                      )[0].label
                                    : t("CHOOSE_FROM_LIST_OR_ENTER_MANUALLY")
                                }
                                value={remarkOption.filter(
                                  (option) => option.value == value
                                )}
                                onChange={(e, { action }) => {
                                  switch (action) {
                                    case "select-option":
                                      onChange(e.value);
                                      trigger("remark");
                                      break;
                                    case "create-option":
                                      remarkOption.push(e);
                                      onChange(e.value);
                                      trigger("remark");
                                      break;
                                  }
                                }}
                              />
                            );
                          }}
                        />
                        {errors.remark && (
                          <div className="invalid-feedback">
                            {t(errors.remark.message)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-lg-3">
                    <div className="form-group">
                      <button type="submit" className="btn btn-primary">
                        {t("SAVE")}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </PanelBody>
          </Panel>
        </div>
      </div>
      {/*<Modal fade={false} contentClassName="modal-brand modal-bottom modal-numpad" isOpen={showPinEntry} centered>*/}
      {/*  <ModalBody>*/}
      {/*    <form onSubmit={handleSubmit(onPinSubmit)}>*/}
      {/*      <div className="display-wrapper">*/}
      {/*        <button type="button" style={{*/}
      {/*          alignSelf: "flex-end", backgroundColor: "transparent", border: "none", marginRight: "15px", fontSize: "2rem", color: "#002e6c", marginTop: "-15px", float: "right", fontWeight: "bold"*/}
      {/*        }} onClick={() => { setShowPinEntry(false); }} data-dismiss="modal" aria-hidden="true">&times;</button>*/}
      {/*        <strong className="reload-title text-yellow mb-3 d-block" style={{ fontSize: "20px" }}>{t("ENTER_YOUR_PIN")}</strong>*/}
      {/*        <PinInput*/}
      {/*          length={4}*/}
      {/*          initialValue=""*/}
      {/*          secret={true}*/}
      {/*          focus={true}*/}
      {/*          autoSelect={true}*/}
      {/*          type="numeric"*/}
      {/*          onChange={(value, index) => {*/}
      {/*            checkPinValue(value, index);*/}
      {/*          }}*/}
      {/*          inputMode="numeric"*/}
      {/*          inputStyle={{ border: "0", margin: "0px 10px", width: "40px", height: "40px", backgroundColor: "transparent", borderBottom: "2px solid #002e6c" }}*/}
      {/*          inputFocusStyle={{ borderBottom: "2px solid #FFC159" }}*/}
      {/*          regexCriteria={/^[ 0-9_@./#&+-]*$/}*/}
      {/*        />*/}
      {/*        */}{/*<button type="submit" style={{ position: "relative", marginTop: "30px", width: "250px" }} className="btn btn-block btn-brand-gradient btn-sticky-bottom">{t("SUBMIT_TRANSACTION")}</button>*/}
      {/*        */}{/*<div className="invalid-feedback" style={{ fontSize: "12px", marginTop: "1rem" }}>{invalidPin && t("PIN_DOES_NOT_MATCH")}{!invalidPin && <span>&nbsp;</span>}</div>*/}

      {/*      </div>*/}
      {/*    </form>*/}
      {/*  </ModalBody>*/}
      {/*</Modal>*/}
    </div>
  );
};

export default Adjustment;
